module.exports = __webpack_public_path__ + "img/智能连线-规则.5f6f14bf.svg";